var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Common", name: "common" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Slug", prop: "slug" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.slug,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "slug", $$v)
                          },
                          expression: "form.slug",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Title", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Logo", prop: "logo" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.logo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logo", $$v)
                          },
                          expression: "form.logo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Default phone number",
                        prop: "default_phone_number",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.form.default_phone_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "default_phone_number", $$v)
                          },
                          expression: "form.default_phone_number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "Styles", name: "styles" } },
                [
                  _c("styles", {
                    attrs: { schema: _vm.schema },
                    model: {
                      value: _vm.form.styles,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "styles", $$v)
                      },
                      expression: "form.styles",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.store } },
        [_vm._v("Save")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }